export default __webpack_public_path__ + "static/media/spin.e5cea4c6.mp3";